import React from 'react';
import { Box, Button, ButtonBase, Typography, IconButton } from '@mui/material';
import { CloseOutlined, PlayArrowOutlined } from '@mui/icons-material';
import Tooltip from '../LibraryTooltip';
import { CAPABILITY_TYPE_OPTIONS } from '../../../constants/builderCategories';
import { mergeVariablesFromTemplate } from '../../../utils/promptVariables';
import { getAssistantInputValues } from '../../freestyle/assistantInputs';

export default function ExecutePromptsSection({ prompts = [], onOpenFullScreen, onExecute, onRemove, onOpenVariables, variableValues = {}, isExecuting, activePromptId = null }) {
  if (!prompts.length) return <Typography variant="caption" color="text.secondary">No capability selected</Typography>;
  return prompts.map((prompt) => {
    const active = String(activePromptId) === String(prompt.id);
    const type = CAPABILITY_TYPE_OPTIONS.find((option) => option.value === (prompt.capabilityType || 'prompt'))?.label || 'Simple';
    const variables = mergeVariablesFromTemplate(prompt.rawPromptTemplate || prompt.promptText || prompt.content || prompt.prompt || '', prompt.variables || []);
    const filled = Object.values(getAssistantInputValues(variables, variableValues)).filter((value) => value.trim()).length;
    return (
      <Box key={prompt.id || prompt.name} sx={{ py: 0.5, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
          <ButtonBase onClick={() => onOpenFullScreen?.(prompt)} disabled={!onOpenFullScreen} sx={{ flex: 1, minWidth: 0, textAlign: 'left', justifyContent: 'flex-start', py: 0.25 }}>
            <Typography sx={{ fontSize: '0.8125rem', fontWeight: active ? 700 : 600, overflowWrap: 'anywhere' }}>{prompt.name || 'Untitled capability'}</Typography>
          </ButtonBase>
          {onExecute && <Tooltip title="Run this capability"><span><IconButton size="small" aria-label={`Run ${prompt.name}`} disabled={isExecuting} onClick={() => onExecute(prompt)}><PlayArrowOutlined sx={{ fontSize: 17 }} /></IconButton></span></Tooltip>}
          {onRemove && <Tooltip title="Remove from workspace"><IconButton size="small" aria-label="Remove capability from workspace" onClick={() => onRemove(prompt)}><CloseOutlined sx={{ fontSize: 16 }} /></IconButton></Tooltip>}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75 }}>
          <Typography variant="caption" color="text.secondary">{type}</Typography>
          {variables.length > 0 && (active || prompts.length === 1) && onOpenVariables && (
            <Button size="small" onClick={onOpenVariables} sx={{ p: 0.25, minWidth: 0, fontSize: '0.75rem' }}>Inputs · {filled}/{variables.length}</Button>
          )}
        </Box>
      </Box>
    );
  });
}
